import styled from "styled-components";

export const ContentListCard = styled.div`
  border: 1px solid ${({ theme }) => theme.neutral.gray[600]};
  border-bottom: ${({ itemState, identity, highPriority, theme }) => {
    if (
      (typeof itemState === "number" && itemState === 2) ||
      (typeof itemState === "string" &&
        itemState?.toUpperCase() === "ACTIVE") ||
      (typeof itemState === "string" && itemState?.toUpperCase() === "ACCEPT")
    )
      return `5px solid ${theme.primary.greenDark}`;

    if (
      typeof itemState === "string" &&
      itemState?.toUpperCase() === "UNCONFIRMED"
    )
      return `5px solid ${theme.status.successLight}`;

    if (typeof itemState === "number" && itemState === 1) return "";
    if (
      typeof itemState === "number" &&
      itemState === 5 &&
      identity !== "detail-report-list"
    )
      return `5px solid ${theme.status.warningPale}`;

    if (
      typeof itemState === "number" &&
      itemState === 6 &&
      identity !== "detail-report-list"
    )
      return `5px solid ${theme.status.infoPale}`;

    if (
      typeof itemState === "number" &&
      itemState === 7 &&
      identity !== "detail-report-list"
    )
      return `5px solid ${theme.primary.red}`;

    if (
      typeof itemState === "string" &&
      itemState?.toUpperCase() === "DECLINED"
    )
      return `5px solid ${theme.status.errorPale}`;

    if (
      (typeof itemState === "number" &&
        itemState === 3 &&
        identity !== "detail-report-list") ||
      (typeof itemState === "number" &&
        itemState !== 2 &&
        identity === "detail-report-list") ||
      (typeof itemState === "string" && itemState?.toUpperCase() === "INACTIVE")
    )
      return `5px solid ${theme.status.inactive}`;

    if (highPriority) return `5px solid ${theme.primary.redLight}`;

    if (!itemState) return "5px solid inherit";
  }};
  border-radius: 2px;
  color: ${({ theme }) => theme.neutral.gray[3200]};
  box-shadow: 0px 2px 8px rgba(46, 46, 46, 0.1);

  &:hover {
    box-shadow: 0px 2px 20px rgba(46, 46, 46, 0.1);
    cursor: pointer;
  }
`;

// export const ContentListCard = styled.div`
//   border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
//   ${(props) => {
//     if (
//       props.identity !== "event-list" &&
//       props.identity !== "event-categories"
//     ) {
//       return borderTop(props.itemState, props.highPriority);
//     } else if (
//       props.identity === "event-list" ||
//       props.identity === "event-categories"
//     ) {
//       return borderBottom(props.itemState, props.highPriority);
//     }
//   }};
//   border-radius: 2px;
//   color: ${({ theme }) => theme.primary.purple};

//   &:hover {
//     box-shadow: 0px 2px 8px rgba(46, 46, 46, 0.1);
//     cursor: pointer;
//   }
// `;

export const ToolName = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  margin: 1em 0em 1em 1em;
  text-transform: capitalize;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Name = styled.p`
  display: flex;
  align-items: center;
  text-align: ${({ identity }) =>
    identity === "my-insights" || identity === "my-cases" ? "left" : "center"};
  font-size: 14px;
  font-weight: 600;
  margin: ${({ identity }) =>
    identity === "my-insights" || identity === "my-cases"
      ? "0.5em 0.5em 0em"
      : "0px 1em"};
  height: ${({ identity }) =>
    identity === "my-insights" || identity === "my-cases" ? "inherit" : "3em"};
  text-transform: capitalize;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ContainInfo = styled.div`
  padding: 0.5em 1em 0.5em 1em;
  display: grid;
  grid-template-columns: ${({ identity }) =>
    identity === "event-list" ? "65% 30%" : "100%"};
  .info-container {
    display: flex;
    width: 85%;
    justify-content: space-between;
  }
`;

export const ContentUserInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1em 1em 0.5em;
  cursor: pointer !important;
  p {
    font-size: 11px;
    height: 0;
  }
`;
export const StartButton = styled.div`
  color: ${({ theme }) => theme.primary.purple};
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-decoration-line: underline;
`;
export const Start = styled.div`
  display: flex;
  width: 50%;
  padding: 11px 0px;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  flex-shrink: 0;
  border-radius: 4px;
`;

export const RatingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 0 0.2em;
  cursor: pointer !important;
  p {
    font-size: 11px;
    height: 0;
  }
`;

export const LinearContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 0 1em;
  cursor: pointer !important;
  p {
    font-size: 11px;
    height: 0;
  }
`;

export const Id = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.neutral.gray[1200]};
  display: flex;
  flex-direction: row;
`;

export const CreateUser = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.neutral.gray[1200]};
  font-weight: 400;
  display: flex;
  flex-direction: row;
  width: 100px;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Country = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.neutral.gray[1200]};
  font-weight: 400;
  display: flex;
  flex-direction: row;
  width: 130px;
  overflow-x: hidden;
  text-overflow: ellipsis;
`;

export const OtherInfo = styled.p`
  margin-left: 1.1em;
  margin-top: 0.5em;
  align-items: center;
  margin-bottom: 0.5em;
  max-height: 2em;
  font-size: 12px;
  span {
    max-width: 10em;
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const ButtonLinkActive = styled.button`
  text-decoration-line: underline;
  border: 0px solid;
  border-radius: 6px;
  background: ${({ theme }) => theme.primary.purple};
  width: 40%;
  height: 30px;
  margin-left: 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.neutral.white};
  justify-content: center;
`;

export const Hr = styled.div`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.neutral.gray[600]};
`;

export const ContainButtons = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  ${({
  displayProperty,
  displayPropertyInfoIcon,
  displayPropertyUnderApproval,
}) => {
    if (displayPropertyUnderApproval) {
      return "justify-content:  space-between";
    }
    return `justify-content: ${displayProperty && !displayPropertyInfoIcon ? "space-between" : "flex-end"
      }`;
  }}
`;

export const ContainNameTools = styled.div`
  display: flex;

  align-content: center;
  align-items: center;
  justify-content: space-between;
`;

export const ButtonViewPreview = styled.div`
  display: flex;
  justify-content: flex-end;
  justify-self: center;
  align-self: center;
  align-items: center;
  background-color: ${({ theme }) => theme.primary.purple};
  color: ${({ theme }) => theme.neutral.white};
  width: 3.4375em;
  height: 1.5625em;
  margin-right: 0.8em;
  ${(props) =>
    !props.disabled
      ? `
      &:hover {
        color: ${props.theme.neutral.white};
        box-shadow: 0px 4px 20px 0px ${props.theme.primary.purpleLightOpacity};
        transform: translateY(-1px);
        background-color: ${props.theme.primary.purple};
      }
    `
      : `
      opacity: 0.5;
      &:hover {
        color: ${props.theme.neutral.white};
        box-shadow: 0px 4px 20px 0px ${props.theme.primary.purpleLightOpacity};
        transform: translateY(-1px);
        background-color: ${props.theme.primary.purple};
      }
    `};
`;

export const ContentUser = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.neutral.gray[3200]};
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.2em 1em 0.2em;
  height: 3em;
`;

export const ContentHr = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0.5em 0;
`;

export const UserText = styled.div``;

export const ContentInternal = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 2px 0.5em;
`;

export const InternalReviewText = styled.div`
  color: ${({ theme }) => theme.neutral.gray[1200]};
  font-size: 11px;
  font-weight: 600;
`;

export const DateText = styled.div`
  color: ${({ theme }) => theme.neutral.gray[1200]};
  font-size: 10px;
`;

export const ContentComments = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 2px 0.5em 11px;
`;

export const Comments = styled.div`
  color: ${({ theme }) => theme.neutral.gray[1200]};
  font-size: 10px;
`;

export const IdText = styled.div`
  color: ${({ theme }) => theme.neutral.gray[1200]};
  font-size: 13px;
  text-transform: uppercase;
`;

export const TotalReviewLink = styled.p`
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const TotalLinearLink = styled.p`
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const BoxColor = styled.div`
  width: 1em;
  max-width: 100px;
  height: 1em;
  max-height: 100px;
  border-radius: 50%;
  margin-top: 0.2em;
  background: ${({ colorBackground }) => colorBackground};
`;
